import SvgIcon from '@mui/material/SvgIcon';
import type { SvgIconProps } from '@mui/material/SvgIcon';

export default function MdcvVerifiedBadge(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 64 64" aria-label="Verified medical profile" role="img">
      {/* mdcv.me Verified Badge (12-point rosette + plus) */}
      {/* Starburst rosette (single color; inherits from CSS `color`) */}
      <polygon
        fill="#10B981"
        points="32.000,4.000 37.435,11.716 46.000,7.751 46.849,17.151 56.249,18.000 52.284,26.565
                60.000,32.000 52.284,37.435 56.249,46.000 46.849,46.849 46.000,56.249 37.435,52.284
                32.000,60.000 26.565,52.284 18.000,56.249 17.151,46.849 7.751,46.000 11.716,37.435
                4.000,32.000 11.716,26.565 7.751,18.000 17.151,17.151 18.000,7.751 26.565,11.716"
      />
      {/* Plus mark (sharp ends) */}
      <g fill="#fff">
        <rect x="29" y="18" width="6" height="28" />
        <rect x="18" y="29" width="28" height="6" />
      </g>
    </SvgIcon>
  );
}
